/* file which contains all interfaces that stream through the application */

// Generated using typescript-generator version 1.30.385 on 2018-01-29 11:52:44.

import {
  Oauth2TokenResponse,
  ProformaDetailsManagementDef
} from "@/model/component.model";
import { ContentFormatType } from "@/model/enumeration.model";

export interface ConfigurationDTO {
  tenantId?: number;
  multistoreId?: number;
  storeId?: number;
  customerId?: number;
  confKey: string;
  confValue: string;
}

export interface CustConfigurationDTO {
  useCommercialName?: boolean;
  addictionalHandling?: boolean;
  custConfigurationId?: number;
  defaultVatOnExemptArticles?: boolean;
  emailAddressForInvoice: string;
  extraCostsUsingMbeRules: boolean;
  language: string;
  mbeNotification?: boolean;
  sdaClientInformation: boolean;
  sendDetailedInvoice?: boolean;
  sendInvoiceByEmail: boolean;
  shipmentInvoiceable?: boolean;
  shipmentMbeNotificationToCustomer: boolean;
  shipmentMbeNotificationToRecipient: boolean;
  shipmentRts?: boolean;
  showCourierTrackingOnNotification: boolean;
  showInvoiceCustomNote?: boolean;
  showShipmentCustomNote?: boolean;
  tenantId?: number;
  upsQuantumView?: boolean;
  enableQapla: boolean;
}

export interface ZipRegistryEntryIdDto {
  country: string;
  countryName: string;
  postcodeFrom: string;
  postcodeUntil: string;
  townName: string;
  province?: string;
}

export interface ZipRegistryEntryDto {
  id: ZipRegistryEntryIdDto;
  country: string;
  countryName: string;
  postcodeFrom: string;
  postcodeUntil: string;
  townName: string;
  province?: string;
  destinationStation?: string;
  depotName?: string;
  controllingStation?: string;
  zone?: string;
  satelliteCode?: string;
  guaranteed?: string;
  elite?: string;
  deliveryParty?: string;
  saturday?: string;
  domFlag?: string;
}

export interface AddressLocatorDto {
  address: string;
  secondAddress?: string;
  thirdAddress?: string;
  province: string;
  city: string;
  countryId: string;
  zipCode: string;
  pickupExemption: boolean;
  flavour: string;
  ltz: string | boolean;
  upsPublicAccessPointId?: string;
  gelPudoPointId?: string;
  gelNetworkCode?: string;
  locatorName: string;
  distance: number;
  unitOfMisure: string;
  locatorPublicId?: string;
  phoneNumbers: string[];
  latitude: number;
  longitude: number;
  companyName?: string;
}

export interface BankAccountDTO {
  id?: number;
  multiStoreId?: number;
  storeId?: number;
  customerId?: number;
  tenantId: number;
  bankId: string;
  bankName: string;
  bankDetailId: string;
  bankDetailName: string;
  owner: string;
  accountNumber: string;
  bicSwift: string;
  iban: string;
  showOnInvoiceOrder: number | null;
  ribaCharge: boolean | null;
}

export interface CustomerDTO {
  commercialName?: string;
  customerMbeId?: string;
  businessName: string;
  multiStoreId: number;
  defaultStoreId: number;
  customerType: ClientType | string;
  tenantId: number;
  vatNumber: string;
  vatCode: string;
  eori: string;
  fiscalCode: string;
  cnaeCode: string;
  active: boolean;
  shipmentNote: string;
  shipmentNoteEnable: boolean;
  documentNote: string;
  documentNoteEnable: boolean;
  invoiceExportType?: string;
  fixedPaymentDay?: number;
  grossAmount?: number;
  usedAmount?: number;
  residualAmount?: number;
  paymentTermId?: number;
  paymentMethodId?: number;
  saleExtraServicesPricelistId?: number;
  volumetricCoefficientId?: number;
  fuelCalculationId?: number;
  customerConfigurationId?: number;
  bankAccount?: BankAccountDTO;
  custConfiguration: CustConfigurationDTO;
  department?: DepartmentDTO;
  pickingAddress?: ContactDTO;
  address?: ContactDTO;
  publicAdministration: boolean;
}

export interface PriceListDTO {
  priceListMbeId: string;
  name: string;
  creationDate: string;
  lastChangeDate: string;
  shipmentNumber: number;
  clientsNumber: number;
  favourite: boolean;
  selected: boolean;
}

export interface ContactDTO {
  molUsername: string;
  id?: number;
  firstname: string;
  lastname: string;
  gender?: string;
  contactType: ContactContactType;
  birthDate?: string;
  contactsReference: ContactReferenceDTO[];
  addresses: AddressDTO[];
  defaultContact?: boolean;
  addressNickname?: string;
}

export interface SmartChoiceDTO {
  smartChoiceName: string;
  smartChoiceDescription: string;
  smartChoiceNotes: string;
  idRangeConfName: number;
  idZonesChartConfName: number;
  idStore: number;
  idMs: number;
  idUser: number;
  smartChoiceEntries: PriceListDTO[];
}

export interface DepartmentDTO {
  departmentId?: number;
  tenantId: number;
  departmentBusinessName: string;
  departmentPaymentTerm: string;
  invoiceable: boolean;
  contactPersonRef: number;
  customerMBId: string;
  defaultAssigned: boolean;
  address: ContactDTO;
}

export interface AddressDTO {
  id?: number;
  tenantId: number;
  address: string;
  secondAddress: string;
  thirdAddress: string;
  type: AddressType;
  province: string;
  city: string;
  countryName: string;
  countryId: string;
  subCountryName?: string;
  subCountryId?: number;
  state: string;
  zipCode: string;
  entityId?: number;
  entityType?: EntityReferenceType;
  pickupExemption: boolean;
  ltz?: boolean;
  flavour?: string;
}

export interface PageDTO {
  totalPages: number;
  totalElements: number;
  sort: any;
  numberOfElements: number;
  last: boolean;
  first: boolean;
  size: number;
  number: number;
  content: any[];
}

export interface AgentDTO {
  id?: number;
  storeId: number;
  multiStoreId: number;
  agentIdentify?: number;
  tenantId?: number;
  role: AgentRoles;
  contactId?: number;
  contact: ContactDTO;
  description: string;
}

export interface ContactReferenceDTO {
  id?: number;
  value: string;
  type: ContactType;
  entityId?: number;
  entityType?: EntityType;
}

export interface UserDTO {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  tenantId: number;
  password: string;
  email: string;
  google_account: boolean;
  active: boolean;
  contact: ContactDTO;
}

export interface LegalEntityDTO {
  id: number;
  idEntity: number;
  idEntityType: string;
  roles: RoleDTO[];
  description: string;
}

export interface RoleDTO {
  id: number;
  name: string;
  description: string;
  functionalities: FunctionalityDTO[];
}

export interface FunctionalityDTO {
  id: number;
  name: string;
  description: string;
  operation: string;
}

export interface ZonesChartDTO {
  idZonesChart: number;
  zonesChartName: string;
  zonesChartDescription: string;
  zonesChartType?: zonesChartType;
  defaultZone?: boolean;
  idReferenceZonesChart?: number | null;
  tenantId?: number | null;
}

export interface CustomZoneDTO {
  idCustomZone?: number;
  idZonesChartConfName: string;
  idMs: number;
  zoneName: string;
  zoneDescription: string;
  zoneOrder?: number;
  tenantId?: number;
}

export interface ZoneElementCustomZoneAssociationDTO {
  ids: number[];
  customZoneId: number;
  tenantId?: number;
}

export interface MbeServiceDTO {
  idMBEService: number;
  mbeServiceName: string;
  mbeServiceDescription: string | null;
  idMBEBusiness: number;
  tenantId?: number;
}

export interface CourierServiceDTO {
  idCourierService: number;
  tenantId: number;
  courierServiceName: string;
  courierInternalCodeOne: string;
  courierInternalCodeTwo: string;
  courierServiceDescription: string;
  idCourier: number;
  courierName: string;
  idBusiness: number;
  sameForReturn: boolean;
}

export interface ZoneElementDTO {
  idMbeZoneElement: number;
  idMbeZone: null | null;
  idMbeService: number | null;
  mbeZoneName: string;
  mbeZoneElementDescription: string | null;
  mbeServiceName: string | null;
  shipmentType: ShipType;
  idSubcountryFrom: number;
  idSubcountryTo: number;
  tenantId?: number;
}

export interface SubcountryDTO {
  idSubcountry: number;
  idMBEBusiness: number;
  idMBEBusinessCountry: number;
  countryName: string;
  countryCode: string;
  description: string;
  cee: boolean;
  idVat: number;
  idMacroarea: number;
  macroareaName: string | null;
  filterZipFrom: string;
  filterZipTo: string;
  filterCountryCode: string;
  tenantId: number;
  countryId: number | null;
  zipFrom: string;
  zipTo: string;
}

export interface SmartChoiceConsultationInputDTO {
  idMBECustomer?: string;
  marginPercentage: number;
  marginOnSurcharges: boolean;
  idSubcountryFrom: number;
  idSubcountryTo: number;
  placeName: string;
  zipCode: string;
  idMBEService: number;
  idMBEPackType: number;
  shipType: ShipType;
  weight: number;
  packageNumber: number;
  packages: SmartChoiceConsultationPackageDTO[];
  pickupDate: string;
  smartChoiceConsultationSurchargesList: SmartChoiceConsultationSurchargeDTO[];
  idStore: number;
  idMs: number;
  countryCode: string;
}

export interface SmartChoiceConsultationPackageDTO {
  sequence: number;
  depth: number;
  width: number;
  height: number;
  customerWeight: number;
  courierWeight: number;
  customerTaxedWeight: number;
  courierTaxedWeight: number;
}

export interface SmartChoiceConsultationSurchargeDTO {
  idSurcharge?: number;
  surchargeName: string;
}

export interface VolumetricDivisorDTO {
  type: string;
  idCourier: number;
  courierName: string;
  serviceName: string;
  idService: number;
  macroarea: string;
  value: number;
  idStore?: number | null;
  idMultiStore: number | null;
}

export interface PrePaidPackageDTO {
  prepaidCreditId?: number;
  tenantId?: number;
  customerId?: number;
  creditAmount: number;
  usedCredit: number;
  residualCredit: number;
  expireDate: string;
  vatId: number;
  mosId: number;
}

export type zonesChartType = "PRICELIST" | "PRINT";

export type ClientType = "OCCASIONAL" | "HABITUAL" | "PROSPECT";

export type AddressType =
  | "RESIDENCE"
  | "DOMICILE"
  | "OFFICE"
  | "SENDER"
  | "RECEIPT"
  | "OPERATION"
  | "REGISTERED"
  | "DEPARTMENT"
  | "SHIPMENT";

export type EntityReferenceType =
  | "CONTACT"
  | "STORE"
  | "CUSTOMER"
  | "DEPARTMENT";

export type AgentRoles =
  | "GRAPHIC"
  | "SHIPMENT"
  | "LOYALTY"
  | "LOYALTY_STAFF"
  | "ADMINISTRATIVE"
  | "OPERATIONAL"
  | "COMMERCIAL";

export type ContactContactType = "AGENT" | "CONTACT" | "IMPORTER";

export type ContactType =
  | "TELEPHONE"
  | "TELEPHONE1"
  | "TELEPHONE2"
  | "CELLULAR"
  | "EMAIL"
  | "EMAIL1"
  | "EMAIL2"
  | "EMAIL_INVOICES"
  | "EMAIL_CERTIFIED"
  | "FAX"
  | "CONTACT_NAME";

export type EntityType = "CONTACT" | "STORE" | "CUSTOMER";

export type ShipType = "DOMESTIC" | "IMPORT" | "EXPORT" | "INTRAWW";

export interface WineCourierServiceDTO {
  courierName: string;
  courierServiceName: string;
  disabled: boolean;
  idBusiness: number;
  idCourier: number;
  idCourierService: number;
  idMBEService: number;
  sameForReturn: boolean;
  tenantId: number;
  thirdPartyEnabled: boolean;
  courierBusinessId?: number;
}

export type SurchargeType =
  | "EXTRASERVICE"
  | "EXTRASERVICE_MBE"
  | "SURCHARGE"
  | "SURCHARGE_LATER_APPLIED";

export type SourceTypeBusinessType =
  | "SINGLE_SHIPMENT"
  | "MASSIVE_SHIPMENT"
  | "SINGLE_SHIPMENT_GERMANGUI"
  | "ONLINEMBE_WAYBILL"
  | "ONLINEMBE_NOWAYBILL"
  | "MBEELINKPLUGIN_WAYBILL"
  | "MBEELINKPLUGIN_NOWAYBILL"
  | "MBEELINKAPI_WAYBILL"
  | "MBEELINKAPI_NOWAYBILL"
  | "EBAY_CONNECTOR"
  | "CSV_CONNECTOR"
  | "MBEWEBSITE_ECOMMERCE"
  | "CAMPUSSHIP"
  | "INTERNETSHIPPING"
  | "QUANTUMVIEW"
  | "INVOICECHECK"
  | "TRACKING";

export interface BankInformationsDTO {
  firtLevel: FirstLevelDTO[];
  secondLevel: SecondLevelDTO[];
  thirdLevel: ThirdLevelDTO[];
  bankInformation: BankInformationDTO[];
}

export interface CountryDTO {
  id: string;
  name: string;
  translatedName?: string;
}

export interface FirstLevelDTO {
  countryName: string;
  countryId: string;
}

export interface SecondLevelDTO {
  countryName: string;
  countryId: string;
  bankId: string;
  bankName: string;
}

export interface ThirdLevelDTO {
  bankDetailId: string;
  bankDetailName: string;
  countryName: string;
  countryId: string;
  bankId: string;
  bankName: string;
}

export interface BankInformationDTO {
  address: string;
  city: string;
  zip: string;
  province: string;
  countryName: string;
  countryId: string;
  bankId: string;
  bankName: string;
  bankDetailId: string;
  bankDetailName: string;
}

export interface VatValuesDTO {
  id: number;
  code: string;
  description: string;
  percentage: number;
  note: string;
  baseCondition: boolean;
  fromValidityDate: number;
  vatType: string;
  countryId: string;
}

export interface PaymentMethodDTO {
  id?: number;
  idMultiStore: number;
  description: string;
  paymentType: PaymentType;
}

export interface PaymentTermsDTO {
  id?: number;
  idMultiStore?: number;
  description: string;
  days: number;
  monthDay: number;
  endOfMonth: boolean;
  nextWorkingDay: boolean;
  numInstallments: number;
  immediate: boolean;
  defaultPaymentTerm: boolean;
}

export interface extraServicesDto {
  idMBEService: number;
  tenantId: number;
  mbeServiceName: string;
  mbeServiceDescription: string;
}

export interface extraServicesPriceDto {
  mbeExtraServiceId: number;
  tenantId: number;
  description: string;
  extraServiceOrder: number;
  changeableAnyTime: boolean;
}

export interface CourierDTO {
  idCourier: number;
  idMBEBusiness: number;
  tenantId: number;
  courierName: string;
  courierDescription: string;
  idDefaultTier: number;
  idBusinessTier: number;
  courierOrdering: number;
  customDutiesVisibility: boolean;
  admitPickup: boolean;
  supportsCOD?: boolean;
}

export interface MbeRangeDTO {
  idMBERangeConfName: number;
  rangeConfName: string;
  rangeConfDescription: string;
  tenantId?: number;
  idMs?: number;
}

export type PaymentType = "CASH" | "SEPA" | "RIBA" | "RECEIPT";

export interface ProformaDetailsDTO {
  position: number;
  countryOfOrigin: string;
  measureOfMeasurement: string;
  measureOfMeasurementSecondary: string;
  coefficient: number;
  itemsNumber: number;
  itemsTotalValue: number;
  description: string;
  descriptiveRow: boolean;
  articleId: number;
  itemsSingleValue: number;
  type: number;
  hsCode?: string;
  category?: string;
  gender?: string;
  material?: string;
  mbeMeasureUnitCode?: string;
}

export interface ZonosProformaDetailsDTO extends ProformaDetailsDTO {
  currency: string;
}

export interface ZonosProformaDTO {
  items: ZonosProformaDetailsDTO[];
  languageCode: string;
  shipFromCountry: string;
  shipToCity: string;
  shipToCountry: string;
  shipToPostalCode: string;
  shipToState: string;
  shippingAmount: string | number;
  shippingAmountDiscount: string | number;
  courierServiceId: string | number | null;
  currency: string;
  incoterms: string;
}

export interface ZonosCalculateResponseItemDTO {
  articleId: string | number;
  hsCode: string;
  position: number;
  restricted: boolean;
}

export interface CustomDutyValueDTO {
  netValue: number;
  grossValue: number;
  vatCode: string;
}

export interface CustomDutyDetailsDTO {
  duties: CustomDutyValueDTO;
  zonosFee: CustomDutyValueDTO;
  taxes: CustomDutyValueDTO;
  fees: CustomDutyValueDTO;
}

// Full per-line Zonos landed cost detail (task 4492435474), from GET /tax-and-duties/zonos-landed-cost.
// Zonos Landed Cost provider schema, stored as-is by the BE: typed permissively, every shape-dependent
// decision lives in mapZonosLandedCost() (src/utils/zonosLandedCost.ts).
export interface ZonosLandedCostLineDTO {
  type?: string;
  description?: string;
  note?: string;
  formula?: string;
  amount?: number;
  currency?: string;
  [key: string]: unknown;
}

export interface ZonosLandedCostResponseDTO {
  amountSubtotal?: {
    duties?: number;
    taxes?: number;
    fees?: number;
    [key: string]: unknown;
  };
  duties?: ZonosLandedCostLineDTO[];
  taxes?: ZonosLandedCostLineDTO[];
  fees?: ZonosLandedCostLineDTO[];
  deMinimis?: ZonosLandedCostLineDTO;
  currency?: { base?: string; rates?: unknown; [key: string]: unknown };
  [key: string]: unknown;
}

export interface ZonosCalculateResponseDTO {
  costGuaranteed: boolean;
  items: ZonosCalculateResponseItemDTO[];
  taxAndDutyId: string;
  zonosId?: string;
  totalCosts: number;
  totalGrossCosts: number;
  amountSubtotal: CustomDutyDetailsDTO;
}

export interface ProformaDTO {
  invoiceNumber?: number;
  invoiceDate?: string;
  declarationText?: string;
  additionalComment?: string;
  currency: string;
  eori?: string;
  totalValue: any;
  proformaDetails?: ProformaDetailsDTO[];
  incoterms?: string;
  vatNumber?: string;
  fiscalCode?: string;
  receiverVatNumber?: string;
  receiverFiscalCode?: string;
  receiverEori?: string;
  senderCompanyName: string;
  senderAddress: string;
  senderCity: string;
  senderProvince: string;
  senderZipCode: string;
  senderCountryName: string;
  senderCountryId?: string;
  senderPhone: string;
  invoiceType?: string;
  mbeReasonCode?: string;
  declarationStatement?: string;
  vatStatus?: string;
  receiverCompanyName?: string;
  receiverSecondAddress?: string;
  receiverAddress?: string;
  receiverCity?: string;
  receiverProvince?: string;
  receiverZipCode?: string;
  receiverCountryName?: string;
  receiverCountryId?: string;
  receiverPhone?: string;
  proformaSenderType?: string;
  proformaReceiverType?: string;
  mrnNumber?: string;
  language?: string;
  createdByStore?: boolean;
}

export interface DefaultPickupDataDef {
  note: string;
  time: Date[];
  alternativeTime?: Date[];
  cutOff: string;
}

export interface DefaultPickupDataDTO {
  tenantId: number;
  multistoreId: number;
  storeId: number;
  customerId: string;
  pickupNotes?: string;
  preferredFrom: string;
  preferredTo: string;
  alternativeFrom?: string;
  alternativeTo?: string;
  pickupCutoff: string;
  molUsername: string;
}

export interface MeasurementUnitsDTO {
  id: number;
  code: string;
  description: string;
  weblateKey?: string;
}

export interface DefaultPickupDataDefModal {
  note: string;
  time: Date[];
  alternativeTime?: Date[];
  date: Date;
}

export interface CurrenciesDTO {
  id: number;
  code: string;
  decimals: number;
  fiveDecimalRound: boolean;
}

export type CurrencyType = "EUR" | "USD" | "GBP" | "JPY";

export type ShipmentStatus =
  | "DRAFT_NO_WAYBILL"
  | "DRAFT_WAYBILL"
  | "DRAFT_TO_BE_CLOSED"
  | "CREATED"
  | "IN_TRANSIT"
  | "INVOICED"
  | "FIRST_DRAFT_TO_BE_CLOSED"
  | "OFFER";
export type ShipmentSource =
  | "ONLINE"
  | "WEBSITE"
  | "SYSTEM"
  | "FILE"
  | "APP"
  | "VG7"
  | "MBELAB";
export type AddressShipmentFlavour = "NONE" | "RESIDENTIAL" | "MMR";

export class AddressShipmentDTO {
  constructor(
    public addressId: number = 0,
    public companyName: string = "",
    public address: string = "",
    public secondAddress: string = "",
    public thirdAddress: string = "",
    public city: string = "",
    public province: string = "",
    public zipCode: string = "",
    public subcountryId: number = 0,
    public subcountry: string = "",
    public countryId: string = "",
    public countryName: string = "",
    public contact: string = "",
    public vatNumber: string = "",
    public phone: string = "",
    public fax: string = "",
    public email: string = "",
    public secondEmail: string = "",
    public residential: boolean = false,
    public supermarket: boolean = false,
    public pickupExemption: boolean = false,
    //--public alternativeAddressId: number = 0,
    public macroareaName: string = "",
    public secondPhone: string = "",
    public flavour: AddressShipmentFlavour = "NONE",
    public ltz: boolean = false,
    public cee: boolean = true,
    public eori: string = "",
    public fiscalCode: string = "",
    public addressNickname: string = ""
  ) {}

  static trimStrings(a: any): any {
    Object.keys(a).forEach(k => {
      if (typeof a[k] === "string") a[k] = a[k].trim();
    });
    return a;
  }

  static cloneAddress(s: any) {
    const pick = (key: string, fallback: any) =>
      typeof s[key] !== "undefined" ? s[key] : fallback;

    return AddressShipmentDTO.trimStrings(
      new AddressShipmentDTO(
        pick("addressId", 0),
        pick("companyName", ""),
        pick("address", ""),
        pick("secondAddress", ""),
        pick("thirdAddress", ""),
        pick("city", ""),
        pick("province", ""),
        pick("zipCode", ""),
        pick("subcountryId", 0),
        pick("subcountry", ""),
        pick("countryId", ""),
        pick("countryName", ""),
        pick("contact", ""),
        pick("vatNumber", ""),
        pick("phone", ""),
        pick("fax", ""),
        pick("email", ""),
        pick("secondEmail", ""),
        pick("residential", false),
        pick("supermarket", false),
        pick("pickupExemption", false),
        pick("macroareaName", ""),
        pick("secondPhone", ""),
        pick("flavour", "NONE"),
        pick("ltz", false),
        pick("cee", undefined),
        pick("eori", ""),
        pick("fiscalCode", "")
      )
    );
  }

  public static fromContactDTO(
    contact: ContactDTO,
    address: AddressDTO,
    vatNumber: string,
    macroareaName: string,
    customerBusinessName?: string,
    eori?: string,
    fiscalCode?: string
  ): AddressShipmentDTO {
    const new_address = new AddressShipmentDTO();
    new_address.companyName = customerBusinessName
      ? customerBusinessName
      : contact.firstname.trim();
    if (address.type === "SHIPMENT") {
      // AddressId is the contact id
      if (contact.id !== undefined) new_address.addressId = contact.id;
    }
    new_address.address = address.address;
    new_address.addressId = contact.id;
    new_address.secondAddress = address.secondAddress;
    new_address.thirdAddress = address.thirdAddress;
    new_address.city = address.city;
    new_address.province =
      (address.province || "").trim() || (address.state || "").trim();
    new_address.zipCode = address.zipCode;
    new_address.subcountryId =
      address.subCountryId !== undefined ? address.subCountryId : 0;
    new_address.subcountry =
      address.subCountryName !== undefined ? address.subCountryName : "";
    new_address.countryId = address.countryId;
    new_address.countryName = address.countryName;
    new_address.contact = AddressShipmentDTO.extractContactValue(
      contact.contactsReference,
      "CONTACT_NAME"
    );
    new_address.vatNumber = vatNumber;
    new_address.eori = eori;
    new_address.fiscalCode = fiscalCode;
    new_address.phone = AddressShipmentDTO.extractContactValue(
      contact.contactsReference,
      "TELEPHONE1"
    );
    new_address.secondPhone = AddressShipmentDTO.extractContactValue(
      contact.contactsReference,
      "TELEPHONE2"
    );
    new_address.fax = AddressShipmentDTO.extractContactValue(
      contact.contactsReference,
      "FAX"
    );
    new_address.email = AddressShipmentDTO.extractContactValue(
      contact.contactsReference,
      "EMAIL1"
    );
    new_address.secondEmail = AddressShipmentDTO.extractContactValue(
      contact.contactsReference,
      "EMAIL2"
    );
    //new_address.residential
    new_address.pickupExemption = address.pickupExemption;
    //new_address.alternativeAddressId
    new_address.macroareaName =
      macroareaName === "" ? "NATIONAL" : macroareaName;
    new_address.ltz = address.ltz !== undefined ? false : address.ltz;

    return AddressShipmentDTO.trimStrings(new_address);
  }

  static extractContactValue(contacts: ContactReferenceDTO[], type: string) {
    return contacts
      .filter(i => i.type === type)
      .reduce((a, i) => (a.length === 0 ? i.value : a), "");
  }

  public toContactDTO(contact: ContactDTO | undefined = undefined): ContactDTO {
    // This is to ensure if its an existing contact, id and addressid will be reused
    if (contact === undefined) {
      contact = {} as ContactDTO;
      contact.contactsReference = [] as ContactReferenceDTO[];
      contact.addresses = [{} as AddressDTO];
    }
    contact.firstname = this.companyName;
    contact.lastname = "";
    contact.contactType = "CONTACT";
    AddressShipmentDTO.extractContact(
      contact.contactsReference,
      "CONTACT_NAME"
    );
    AddressShipmentDTO.extractContact(contact.contactsReference, "TELEPHONE1");
    AddressShipmentDTO.extractContact(contact.contactsReference, "TELEPHONE2");
    AddressShipmentDTO.extractContact(contact.contactsReference, "EMAIL1");
    AddressShipmentDTO.extractContact(contact.contactsReference, "EMAIL2");
    contact.contactsReference = contact.contactsReference.map(item => {
      if (item.type === "CONTACT_NAME") {
        item.value = this.contact;
      } else if (item.type === "TELEPHONE1") {
        item.value = this.phone;
      } else if (item.type === "TELEPHONE2") {
        item.value = this.secondPhone;
      } else if (item.type === "EMAIL1") {
        item.value = this.email;
      } else if (item.type === "EMAIL2") {
        item.value = this.secondEmail;
      }

      return item;
    });

    contact.addresses[0].address = this.address;
    contact.addresses[0].secondAddress = this.secondAddress;
    contact.addresses[0].thirdAddress = this.thirdAddress;
    contact.addresses[0].type = "SHIPMENT";
    contact.addresses[0].province = this.province;
    contact.addresses[0].city = this.city;
    contact.addresses[0].countryName = this.countryName;
    contact.addresses[0].countryId = this.countryId;
    contact.addresses[0].subCountryName = this.subcountry;
    contact.addresses[0].subCountryId = this.subcountryId;
    contact.addresses[0].state = this.province;
    contact.addresses[0].zipCode = this.zipCode;
    contact.addresses[0].pickupExemption = this.pickupExemption;

    return contact;
  }

  public static extractContact(contacts: ContactReferenceDTO[], type: string) {
    for (let i = 0; i < contacts.length; i++) {
      if (contacts[i].type === type) {
        return contacts[i];
      }
    }
    const aNewItem = {
      type: type,
      value: ""
    } as ContactReferenceDTO;
    contacts.push(aNewItem);
    return aNewItem;
  }

  public static fromAddressDTO(
    address: AddressDTO,
    storeName: string,
    vatNumber: string,
    macroareaName: string,
    contactReferences: ContactReferenceDTO[],
    eori?: string,
    fiscalCode?: string
  ): AddressShipmentDTO {
    const new_address = new AddressShipmentDTO();

    new_address.companyName = storeName;
    new_address.address = address.address;
    new_address.addressId = address.id;
    new_address.secondAddress = address.secondAddress;
    new_address.thirdAddress = address.thirdAddress;
    if (address.type === "SHIPMENT" && address.entityId !== undefined) {
      //#504384364 fix resuse address id only if type shipment
      new_address.addressId = address.entityId;
    }
    new_address.city = address.city;
    new_address.province = (address.province || "").trim();
    new_address.zipCode = address.zipCode;
    new_address.countryId = address.countryId;
    new_address.countryName = address.countryName;
    new_address.subcountry = address.subCountryName;
    new_address.subcountryId = address.subCountryId;
    new_address.contact = AddressShipmentDTO.extractContactValue(
      contactReferences,
      "CONTACT_NAME"
    );
    new_address.vatNumber = vatNumber;
    new_address.eori = eori;
    new_address.fiscalCode = fiscalCode;
    new_address.phone = AddressShipmentDTO.extractContactValue(
      contactReferences,
      "TELEPHONE1"
    );
    new_address.secondPhone = AddressShipmentDTO.extractContactValue(
      contactReferences,
      "TELEPHONE2"
    );
    new_address.fax = AddressShipmentDTO.extractContactValue(
      contactReferences,
      "FAX"
    );
    new_address.email = AddressShipmentDTO.extractContactValue(
      contactReferences,
      "EMAIL1"
    );
    new_address.secondEmail = AddressShipmentDTO.extractContactValue(
      contactReferences,
      "EMAIL2"
    );
    new_address.pickupExemption = address.pickupExemption;
    new_address.macroareaName =
      macroareaName === "" ? "NATIONAL" : macroareaName;
    return AddressShipmentDTO.trimStrings(new_address);
  }

  public static fromCustomerDTO(customer: CustomerDTO) {
    const address = new AddressShipmentDTO();

    address.companyName = customer.businessName;
    address.vatNumber = customer.vatNumber;
    address.eori = customer.eori;
    address.fiscalCode = customer.fiscalCode;
    if (customer.address != undefined) {
      const ca = customer.address;
      if (ca.addresses != undefined && ca.addresses.length > 0) {
        const caa = ca.addresses[0];
        address.address = caa.address;
        address.secondAddress = caa.secondAddress;
        address.thirdAddress = caa.thirdAddress;
        address.city = caa.city;
        address.province = caa.province;
        address.zipCode = caa.zipCode;
        address.countryId = caa.countryId;
        address.countryName = caa.countryName;
        if (caa.subCountryId != undefined) {
          address.subcountryId = caa.subCountryId;
        }
        if (caa.subCountryName != undefined) {
          address.subcountry = caa.subCountryName;
        }
        address.residential = caa.type == "RESIDENCE";
      }

      if (ca.contactsReference != undefined) {
        const phone1 = ca.contactsReference.find(
          item => item.type === "TELEPHONE1"
        );
        const phone2 = ca.contactsReference.find(
          item => item.type === "TELEPHONE2"
        );
        const email1 = ca.contactsReference.find(
          item => item.type === "EMAIL1"
        );
        const email2 = ca.contactsReference.find(
          item => item.type === "EMAIL2"
        );
        const contactName = ca.contactsReference.find(
          item => item.type === "CONTACT_NAME"
        );

        if (phone1 !== undefined) address.phone = phone1.value;
        if (phone2 !== undefined) address.secondPhone = phone2.value;
        if (email1 !== undefined) address.email = email1.value;
        if (email2 !== undefined) address.secondEmail = email2.value;
        if (contactName !== undefined) address.contact = contactName.value;
      }
    }

    return AddressShipmentDTO.trimStrings(address);
  }
}

export class ShipmentPackageDTO {
  constructor(
    public packTrackingNumber: string = "",
    public mbePackTrackingNumber: string = "",
    public sequence: number = 0,
    public courierWeight: number = 0,
    public courierVolumetricWeight: number = 0,
    public courierTaxedWeight: number = 0,
    public customerWeight: number = 0,
    public customerVolumetricWeight: number = 0,
    public customerTaxedWeight: number = 0,
    public depth: number = 0,
    public width: number = 0,
    public height: number = 0,
    public addHandling?: boolean | null,
    public oversize?: boolean | null,
    public overweight?: boolean | null,
    public itemsNumber: number = 0,
    public specialItemsNumber: number = 0,
    public sent: boolean = false,
    public trackingLastStatusCourier: string = "",
    public trackingLastStatusMbeName: string = "",
    public trackingLastStatusMbeId: number = 0,
    public trackingDate: number = 0,
    public trackingSignature: string = "",
    public delivered: boolean = false,
    public seen: boolean = false,
    public specificPacktype?: string | null,
    //--public packageCourierId: number = 0,
    //--public packageCourierName: string = '',
    public currentPosition: string = "",
    public barCode: string = "",
    public winePackType?: string
  ) {}

  static clonePackage(s: any) {
    return new ShipmentPackageDTO(
      typeof s.packTrackingNumber !== "undefined" ? s.packTrackingNumber : "",
      typeof s.mbePackTrackingNumber !== "undefined"
        ? s.mbePackTrackingNumber
        : "",
      typeof s.sequence !== "undefined" ? s.sequence : 0,
      typeof s.courierWeight !== "undefined" ? s.courierWeight : 0,
      typeof s.courierVolumetricWeight !== "undefined"
        ? s.courierVolumetricWeight
        : 0,
      typeof s.courierTaxedWeight !== "undefined" ? s.courierTaxedWeight : 0,
      typeof s.customerWeight !== "undefined" ? s.customerWeight : 0,
      typeof s.customerVolumetricWeight !== "undefined"
        ? s.customerVolumetricWeight
        : 0,
      typeof s.customerTaxedWeight !== "undefined" ? s.customerTaxedWeight : 0,
      typeof s.depth !== "undefined" ? s.depth : 0,
      typeof s.width !== "undefined" ? s.width : 0,
      typeof s.height !== "undefined" ? s.height : 0,
      typeof s.addHandling !== "undefined" ? s.addHandling : false,
      typeof s.oversize !== "undefined" ? s.oversize : false,
      typeof s.overweight !== "undefined" ? s.overweight : false,
      typeof s.itemsNumber !== "undefined" ? s.itemsNumber : 0,
      typeof s.specialItemsNumber !== "undefined" ? s.specialItemsNumber : 0,
      typeof s.sent !== "undefined" ? s.sent : false,
      typeof s.trackingLastStatusCourier !== "undefined"
        ? s.trackingLastStatusCourier
        : "",
      typeof s.trackingLastStatusMbeName !== "undefined"
        ? s.trackingLastStatusMbeName
        : "",
      typeof s.trackingLastStatusMbeId !== "undefined"
        ? s.trackingLastStatusMbeId
        : 0,
      typeof s.trackingDate !== "undefined" ? s.trackingDate : 0,
      typeof s.trackingSignature !== "undefined" ? s.trackingSignature : "",
      typeof s.delivered !== "undefined" ? s.delivered : false,
      typeof s.seen !== "undefined" ? s.seen : false,
      typeof s.specificPacktype !== "undefined" ? s.specificPacktype : "",
      typeof s.currentPosition !== "undefined" ? s.currentPosition : "",
      typeof s.barCode !== "undefined" ? s.barCode : "",
      typeof s.winePackType !== "undefined" ? s.winePackType : ""
    );
  }

  duplicate() {
    return new ShipmentPackageDTO(
      this.packTrackingNumber,
      this.mbePackTrackingNumber,
      this.sequence,
      this.courierWeight,
      this.courierVolumetricWeight,
      this.courierTaxedWeight,
      this.customerWeight,
      this.customerVolumetricWeight,
      this.customerTaxedWeight,
      this.depth,
      this.width,
      this.height,
      this.addHandling,
      this.oversize,
      this.overweight,
      this.itemsNumber,
      this.specialItemsNumber,
      this.sent,
      this.trackingLastStatusCourier,
      this.trackingLastStatusMbeName,
      this.trackingLastStatusMbeId,
      this.trackingDate,
      this.trackingSignature,
      this.delivered,
      this.seen,
      //--this.packageCourierId,
      //--this.packageCourierName,
      this.currentPosition,
      this.barCode,
      this.winePackType
    );
  }

  cloneFrom(other: ShipmentPackageDTO) {
    if (this !== other) {
      (this.packTrackingNumber = other.packTrackingNumber),
        (this.mbePackTrackingNumber = other.mbePackTrackingNumber),
        (this.sequence = other.sequence),
        (this.courierWeight = other.courierWeight),
        (this.courierVolumetricWeight = other.courierVolumetricWeight),
        (this.courierTaxedWeight = other.courierTaxedWeight),
        (this.customerWeight = other.customerWeight),
        (this.customerVolumetricWeight = other.customerVolumetricWeight),
        (this.customerTaxedWeight = other.customerTaxedWeight),
        (this.depth = other.depth),
        (this.width = other.width),
        (this.height = other.height),
        (this.itemsNumber = other.itemsNumber),
        (this.specialItemsNumber = other.specialItemsNumber),
        (this.trackingLastStatusCourier = other.trackingLastStatusCourier),
        (this.trackingLastStatusMbeName = other.trackingLastStatusMbeName),
        (this.trackingLastStatusMbeId = other.trackingLastStatusMbeId),
        (this.trackingDate = other.trackingDate),
        (this.trackingSignature = other.trackingSignature),
        //--this.packageCourierId = other.packageCourierId,
        //--this.packageCourierName = other.packageCourierName,
        (this.currentPosition = other.currentPosition),
        (this.barCode = other.barCode),
        (this.sent = other.sent),
        (this.overweight = other.overweight),
        (this.addHandling = other.addHandling),
        (this.oversize = other.oversize),
        (this.delivered = other.delivered),
        (this.seen = other.seen),
        (this.winePackType = other.winePackType);
    }
  }
}

export type ExtraserviceSurchargeType =
  | "EXTRASERVICE"
  | "EXTRASERVICE_MBE"
  | "SURCHARGE"
  | "SURCHARGE_LATER_APPLIED";
export type ExtraserviceVisibilityType =
  | "VALUE"
  | "VALUE_CURRENCY_PAYMENT_TYPE"
  | "FREE_DESCRIPTION"
  | "STANDARD"
  | "ARTICLE"
  | "DANGEROUS_GOODS_TYPE"
  | "ISC_TYPE";

export class ShipmentExtraServiceDTO {
  extraServiceName: string;
  mbeBusinessId: number;
  extraServiceTypeId?: number;
  extraServiceTypeName?: string;
  extraServiceTypeInternalCode?: string;
  paymentType?: string;
  autoAdded?: boolean;
  autoApplyCost?: boolean;
  autoApplyPrice?: boolean;
  price?: boolean;
  cost?: boolean;
  vatId: number;
  safeValueDocument?: DocumentDTO;
  vatName: string;
  vatCode: string;
  vatPercentage: number;
  netCost: number;
  grossCost: number;
  netPrice: number;
  grossPrice: number;
  userNetPrice?: number;
  userGrossPrice?: number;
  userNetCost?: number;
  userGrossCost?: number;
  courierExtraServiceTierName?: string;
  currencyId?: number;
  currency?: string;
  extraServiceValue?: number;
  extraServiceTypeNameFromImport?: string;
  surcharge?: boolean;
  surchargeType?: ExtraserviceSurchargeType;
  article?: ShipmentArticleDTO;
  vatEditableByUser?: boolean;
  vatEditableByCustomer?: boolean;
  visibilityType: ExtraserviceVisibilityType;
  profitId?: number;
  profitName?: string;
  applicableOnCost?: boolean;
  applicableOnPrice?: boolean;
  isUserPrice?: boolean;
  isUserCost?: boolean;
  userEditedPrice?: boolean;
  userEditedCost?: boolean;
  calculatedBaseValue?: number;
  order?: number;
  nationalBankAccountNumber?: string;
  iscGoodId?: string;
  extraServiceVisibilityType?: string;
  dismissed?: boolean;
  salePercentage?: number;
  costPercentage?: number;
  saleValue?: number;
  saleMinimum?: number;
  costValue?: number;
  costMinimum?: number;
}

export type WineDimensionType = "WINE" | "SPIRITS";

export interface DimensionsConfigurationDTO {
  tenantId: number;
  storeId: number;
  winePackageType: string;
  quantity: number;
  length: number;
  width: number;
  height: number;
  customerWeight: number;
  courierWeight: number;
  wineProductType: WineDimensionType;
}

export class ShipmentArticleDTO {
  constructor(
    public articleId: number = 0,
    public salesUnitId: number = 0,
    public salesUnitDescription: string = "",
    public articleFullDescription: string = "",
    public articleShortDescription: string = "",
    public articleTypeId: number = 0,
    public articleTypeName: string = "",
    public royaltyExempted: boolean = false,
    public groupId: number = 0
  ) {}
}

export type DocumentType =
  | "WAYBILL"
  | "PROTOCOL"
  | "SENDER_COPY"
  | "CASH_ON_DELIVERY"
  | "PACKAGE_REFERENCE"
  | "ELECTRONIC_RETURN_LABEL_RECEIPT"
  | "CONNOTE"
  | "SAFEVALUE"
  | "ENDDAYFILE"
  | "GENERIC"
  | "RECEIPT"
  | "PROFORMA"
  | "COD"
  | "ELECTRONIC_INVOICE"
  | "OFFER_REPORT"
  | "EXPORT"
  | "PRICELIST_EXPORT"
  | "PROOF_OF_DELIVERY"
  | "SHIPMENT_PALLET_QUOTE_REQUEST"
  | "MBE_WAYBILL";

export type ImageType =
  | "GIF"
  | "PDF"
  | "HTML"
  | "PNG"
  | "JPG"
  | "JPEG"
  | "JPE"
  | "JFIF"
  | "DOCX"
  | "DOCM"
  | "DOTX"
  | "DOTM"
  | "XLSX"
  | "XLSM"
  | "XLTX"
  | "XLTM"
  | "XLSB"
  | "XLAM"
  | "BMP"
  | "TEC"
  | "ZPL"
  | "TXT"
  | "TIF"
  | "TIFF"
  | "EPL";

export type PrintFormatType = "fA4" | "f4x6" | "f4x8" | "f5x9";

export class DocumentDTO {
  constructor(
    public documentType: DocumentType = "WAYBILL",
    public type: ImageType = "PDF",
    public formatType: PrintFormatType = "fA4",
    public contentDocument: string = "",
    public pathDocument: string = "",
    public documentURI: string = "",
    public versionId: string = "",
    public preview: boolean = false
  ) {}
}

export class ShipProductMBEDTO {
  constructor(
    public costMBE: number = 0,
    public idSpecialtyBusiness: number = 0,
    public specialtyName: string = "",
    public idWebService: number = 0,
    public corporate?: number,
    public wineWarehouseId?: number,
    public wine2PricelistType?: string
  ) {}
}

export class SimplifyProformaDTO {
  constructor(public currency: string = "", public totalValue: number = 0) {}
}

export type PickupStatus = "RESERVED" | "" | "PENDING";

export class PickupDTO {
  constructor(
    public pickupDate: string = new Date().toISOString().substring(0, 10),
    public preferredFrom: string = "",
    public preferredTo: string = "",
    public alternativeFrom: string = "",
    public alternativeTo: string = "",
    public bookingIdentificationNumber: string = "",
    public note: string = "",
    public requestLocation: string = "",
    public status?: PickupStatus,
    public deleted: boolean = false,
    public creationDate: number = 0,
    public rejectedReason: string = "",
    public checksum: string = "",
    public pickupSourceDescription?: string
  ) {}
}

export interface ManagePickupRequestDTO {
  pickupDto: PickupDTO;
  shipmentIdList: string[];
}

export class QuantumViewNotificationDTO {
  constructor(
    public idQuantumViewNotification: string = "",
    public useQview: boolean = false,
    public qviewStoreMail: string = "",
    public qviewStoreSent: boolean = false,
    public qviewStoreDelivered: boolean = false,
    public qviewStoreException: boolean = false,
    public qviewSenderMail: string = "",
    public qviewSenderSent: boolean = false,
    public qviewSenderDelivered: boolean = false,
    public qviewSenderException: boolean = false,
    public qviewReceiverMail: string = "",
    public qviewReceiverSent: boolean = false,
    public qviewReceiverDelivered: boolean = false,
    public qviewReceiverException: boolean = false,
    public qviewSender2Mail: string = "",
    public qviewSender2Sent: boolean = false,
    public qviewSender2Delivered: boolean = false,
    public qviewSender2Exception: boolean = false,
    public qviewReceiver2Mail: string = "",
    public qviewReceiver2Sent: boolean = false,
    public qviewReceiver2Delivered: boolean = false,
    public qviewReceiver2Exception: boolean = false
  ) {}
}

export class CourierServiceCodeConfigurationDTO {
  constructor(
    public code: string = "",
    //--public ftpUsername: string = '',
    //--public ftpPassword: string = '',
    public resale: boolean = false
  ) {}
}

export class ShipmentDTO {
  zonosId?: string;
  constructor(
    public shipmentId: string = "",
    public shipmentDirection: string | null = null,
    public tenantId: number = 0,
    public multiStoreId: number = 0,
    public storeId: number = 0,
    public storeCode: number = 0,
    public shipmentDate: string = new Date().toISOString().substring(0, 10),
    public delivered: boolean = false,
    public shipmentType: ShipType = "DOMESTIC",
    public customerId: number = 0,
    public customerName: string = "",
    public customerType: ClientType = "HABITUAL",
    public customerDepartmentId: number = 0,
    public customerDepartment: string = "",
    public addressStore: AddressShipmentDTO = new AddressShipmentDTO(),
    public addressFor: AddressShipmentDTO = new AddressShipmentDTO(),
    public addressFrom: AddressShipmentDTO = new AddressShipmentDTO(),
    public addressTo: AddressShipmentDTO = new AddressShipmentDTO(),
    public addressAccessPoint: AddressLocatorDto | undefined = undefined,
    public fromStore: boolean = false,
    public storeZipCode: string = "",
    public storeCity: string = "",
    public alternativeAddress: AddressShipmentDTO = new AddressShipmentDTO(),
    public importerContactId: number = 0,
    public courierServiceId: number = 0,
    public courierServiceName: string = "",
    public mbeServiceId: number = 0,
    public mbeService: string = "",
    public invoiceMbeServiceId: number = 0,
    public invoiceMbeServiceName: string = "",
    public courierId: number = 0,
    public courierName: string = "",
    public courierWeight: number = 0,
    public courierVolumetricWeight: number = 0,
    public customerVolumetricWeight: number = 0,
    public customerWeight: number = 0,
    public totalNumberOfPackages: number = 0,
    public shipPackTypeId: number = 0, //business ID
    public shipPackType: string = "",
    public courierShipPackTypeId: number = 0,
    public courierShipPackType: string = "",
    public goodTypeId: number = 1,
    public goodType: string = "GOODS",
    public emailSent: boolean = false,
    public notToInvoice: boolean = false,
    public checkWeight: boolean = false,
    public shipmentTrackingNumber: string = "",
    public excludeInvoiceCheck: boolean = false,
    public exception: boolean = false,
    public prepaidCredit: boolean = false,
    public mosDescription: string = "",
    public notes: string = "",
    public goodDescription: string = "",
    public internalNote: string = "",
    public refDescription: string = "",
    public cost: number = 0,
    public totalCost: number = 0,
    public publicPrice?: number,
    public shipNetPrice: number = 0,
    public shipGrossPrice: number = 0,
    public totalShipNetPrice: number = 0,
    public totalShipGrossPrice: number = 0,
    public costMBE: number = 0,
    public totalCostMBE: number = 0,
    public courierRefund: boolean = false,
    public customerRefund: boolean = false,
    public courierRefundDate: number = 0,
    public customerRefundDate: number = 0,
    public shipmentPackages: ShipmentPackageDTO[] = [new ShipmentPackageDTO()],
    //public //[new ShipmentExtraServiceDTO()],
    public extraServices: ShipmentExtraServiceDTO[] = [],
    //public //[new ShipProductMBEDTO()],
    public shipMBEProducts: ShipProductMBEDTO[] = [],
    public originalVersion: string = "",
    public lockedByUser: string = "",
    public proforma: ProformaDTO = {
      currency: "EUR",
      totalValue: 0,
      proformaDetails: []
    } as ProformaDTO,
    public customerDataInSender: boolean = false,
    public customerDataInSenderExceptForAddress: boolean = false,
    //--public simplifyProforma: SimplifyProformaDTO =
    //--	new SimplifyProformaDTO(),
    public pickupRequest: boolean = false,
    public pickupRequested: boolean = false,
    public courierIdentificationNumber: string = "",
    public preferredPickupDate: string = "",
    public pickup: PickupDTO = new PickupDTO(),
    public printPackageReference: boolean = false,
    public customsDutiesToCustomer: boolean = false,
    public clientIdentifier: string = "",
    public documents: DocumentDTO[] = [new DocumentDTO()],
    public customerAccount: string = "",
    public quantumViewNotification: QuantumViewNotificationDTO = new QuantumViewNotificationDTO(),
    public source: ShipmentSource = "ONLINE",
    public status: ShipmentStatus = "DRAFT_TO_BE_CLOSED",
    public manual: boolean = false,
    public courierTaxedWeight: number = 0,
    public customerTaxedWeight: number = 0,
    public checked: boolean = false,
    public accountCongifuration: CourierServiceCodeConfigurationDTO = new CourierServiceCodeConfigurationDTO(),
    public agentName: string = "",
    public freightCollect: boolean = false,
    public specialtyId: number = 0,
    public vatId: number = 0,
    public vatPercentage: number = 0,
    public vatName: string = "",
    public vatCode: string = "",
    public modifiedShipNetPrice: number | null = null,
    public mbeTracking: string = "",
    public locale: string = "",
    public canPrintWayBill: boolean = false,
    public enableCustomerCredit: boolean = false,
    //--public profitId: number = 0,
    //--public profitName: string = '',
    public profitBusinessId: number = 0,
    public currency: string = "EUR",
    public sourceTypeBusiness: SourceTypeBusinessType = "ONLINEMBE_NOWAYBILL",
    public importedShipment: boolean = false,
    public saveShipmentTemplate: boolean = false,
    public priceSource: string = undefined,
    public useOtherExtraServiceAndShipmentAndExtraServiceValueForBase?: boolean,
    public requestedChargeCustomDuties?: boolean,
    public shipmentSource?: string,
    public productElink?: ProductElinkDto[],
    public dismissedExtraServices: ShipmentExtraServiceDTO[] = [],
    public sentPaperlessDocument: boolean = false,
    public paperlessDocumentIds: number[] = [],
    public distanceFromTo?: number,
    public correctionSettings?: CorrectionSettingsDto,
    public autopilotCourierIdBusiness?: number,
    public autopilotCourierName?: string,
    public autopilotFee?: boolean,
    public taxAndDutyId?: string,
    public taxAndDutyPluginAct?: boolean,
    public mbePickupManual?: boolean,
    public ddpZonos?: boolean,
    public pickupDate?: string,
    public landedCosts?: ZonosCalculateResponseDTO | null,
    public requestedChargeCustomDutiesDefinedByMolUser?: boolean,
    public codeAccountForCustomDuties?: string,
    public zipCodeForCustomDuties?: string,
    public countryCodeForCustomDuties?: string,
    public hasAttachment?: boolean,
    public proformaValue?: number,
    public thirdParty?: boolean
  ) {}

  static cloneShipment(s: any) {
    return new ShipmentDTO(
      typeof s.shipmentId !== "undefined" ? s.shipmentId : "",
      typeof s.shipmentDirection !== "undefined" ? s.shipmentDirection : null,
      typeof s.tenantId !== "undefined" ? s.tenantId : 0,
      typeof s.multiStoreId !== "undefined" ? s.multiStoreId : 0,
      typeof s.storeId !== "undefined" ? s.storeId : 0,
      typeof s.storeCode !== "undefined" ? s.storeCode : 0,
      typeof s.shipmentDate !== "undefined"
        ? s.shipmentDate
        : new Date().toISOString().substring(0, 10),
      typeof s.delivered !== "undefined" ? s.delivered : false,
      typeof s.shipmentType !== "undefined" ? s.shipmentType : "DOMESTIC",
      typeof s.customerId !== "undefined" ? s.customerId : 0,
      typeof s.customerName !== "undefined" ? s.customerName : "",
      typeof s.customerType !== "undefined" ? s.customerType : "HABITUAL",
      typeof s.customerDepartmentId !== "undefined"
        ? s.customerDepartmentId
        : 0,
      typeof s.customerDepartment !== "undefined" ? s.customerDepartment : "",
      typeof s.addressStore !== "undefined"
        ? AddressShipmentDTO.cloneAddress(s.addressStore)
        : new AddressShipmentDTO(),
      typeof s.addressFor !== "undefined"
        ? AddressShipmentDTO.cloneAddress(s.addressFor)
        : new AddressShipmentDTO(),
      typeof s.addressFrom !== "undefined"
        ? AddressShipmentDTO.cloneAddress(s.addressFrom)
        : new AddressShipmentDTO(),
      typeof s.addressTo !== "undefined"
        ? AddressShipmentDTO.cloneAddress(s.addressTo)
        : new AddressShipmentDTO(),
      typeof s.addressAccessPoint !== "undefined"
        ? s.addressAccessPoint
        : undefined,
      typeof s.fromStore !== "undefined" ? s.fromStore : false,
      typeof s.storeZipCode !== "undefined" ? s.storeZipCode : false,
      typeof s.storeCity !== "undefined" ? s.storeCity : false,
      typeof s.alternativeAddress !== "undefined"
        ? AddressShipmentDTO.cloneAddress(s.alternativeAddress)
        : new AddressShipmentDTO(),
      typeof s.importerContactId !== "undefined" ? s.importerContactId : 0,
      typeof s.courierServiceId !== "undefined" ? s.courierServiceId : 0,
      typeof s.courierServiceName !== "undefined" ? s.courierServiceName : "",
      typeof s.mbeServiceId !== "undefined" ? s.mbeServiceId : 0,
      typeof s.mbeService !== "undefined" ? s.mbeService : "",
      typeof s.invoiceMbeServiceId !== "undefined" ? s.invoiceMbeServiceId : 0,
      typeof s.invoiceMbeServiceName !== "undefined"
        ? s.invoiceMbeServiceName
        : "",
      typeof s.courierId !== "undefined" ? s.courierId : 0,
      typeof s.courierName !== "undefined" ? s.courierName : null,
      typeof s.courierWeight !== "undefined" ? s.courierWeight : 0,
      typeof s.courierVolumetricWeight !== "undefined"
        ? s.courierVolumetricWeight
        : 0,
      typeof s.customerVolumetricWeight !== "undefined"
        ? s.customerVolumetricWeight
        : 0,
      typeof s.customerWeight !== "undefined" ? s.customerWeight : 0,
      typeof s.totalNumberOfPackages !== "undefined"
        ? s.totalNumberOfPackages
        : 0,
      typeof s.shipPackTypeId !== "undefined" ? s.shipPackTypeId : 0,
      typeof s.shipPackType !== "undefined" ? s.shipPackType : "",
      typeof s.courierShipPackTypeId !== "undefined"
        ? s.courierShipPackTypeId
        : 0,
      typeof s.courierShipPackType !== "undefined" ? s.courierShipPackType : "",
      typeof s.goodTypeId !== "undefined" ? s.goodTypeId : 1,
      typeof s.goodType !== "undefined" ? s.goodType : "GOODS",
      typeof s.emailSent !== "undefined" ? s.emailSent : false,
      typeof s.notToInvoice !== "undefined" ? s.notToInvoice : false,
      typeof s.checkWeight !== "undefined" ? s.checkWeight : false,
      typeof s.shipmentTrackingNumber !== "undefined"
        ? s.shipmentTrackingNumber
        : "",
      typeof s.excludeInvoiceCheck !== "undefined"
        ? s.excludeInvoiceCheck
        : false,
      typeof s.exception !== "undefined" ? s.exception : false,
      typeof s.prepaidCredit !== "undefined" ? s.prepaidCredit : false,
      typeof s.mosDescription !== "undefined" ? s.mosDescription : "",
      typeof s.notes !== "undefined" ? s.notes : "",
      typeof s.goodDescription !== "undefined" ? s.goodDescription : "",
      typeof s.internalNote !== "undefined" ? s.internalNote : "",
      typeof s.refDescription !== "undefined" ? s.refDescription : "",
      typeof s.cost !== "undefined" ? s.cost : 0,
      typeof s.totalCost !== "undefined" ? s.totalCost : 0,
      typeof s.publicPrice !== "undefined" ? s.publicPrice : 0,
      typeof s.shipNetPrice !== "undefined" ? s.shipNetPrice : 0,
      typeof s.shipGrossPrice !== "undefined" ? s.shipGrossPrice : 0,
      typeof s.totalShipNetPrice !== "undefined" ? s.totalShipNetPrice : 0,
      typeof s.totalShipGrossPrice !== "undefined" ? s.totalShipGrossPrice : 0,
      typeof s.costMBE !== "undefined" ? s.costMBE : 0,
      typeof s.totalCostMBE !== "undefined" ? s.totalCostMBE : 0,
      typeof s.courierRefund !== "undefined" ? s.courierRefund : false,
      typeof s.customerRefund !== "undefined" ? s.customerRefund : false,
      typeof s.courierRefundDate !== "undefined" ? s.courierRefundDate : 0,
      typeof s.customerRefundDate !== "undefined" ? s.customerRefundDate : 0,
      typeof s.shipmentPackages !== "undefined"
        ? s.shipmentPackages.map((item: any) => {
            return ShipmentPackageDTO.clonePackage(item);
          })
        : [new ShipmentPackageDTO()],
      typeof s.extraServices !== "undefined" ? s.extraServices : [],
      typeof s.shipMBEProducts !== "undefined" ? s.shipMBEProducts : [],
      typeof s.originalVersion !== "undefined" ? s.originalVersion : "",
      typeof s.lockedByUser !== "undefined" ? s.lockedByUser : "",
      typeof s.proforma !== "undefined"
        ? s.proforma
        : ({
            currency: "EUR",
            totalValue: 0,
            proformaDetails: []
          } as ProformaDTO),
      typeof s.customerDataInSender !== "undefined"
        ? s.customerDataInSender
        : false,
      typeof s.customerDataInSenderExceptForAddress !== "undefined"
        ? s.customerDataInSenderExceptForAddress
        : false,
      typeof s.pickupRequest !== "undefined" ? s.pickupRequest : false,
      typeof s.pickupRequested !== "undefined" ? s.pickupRequested : false,
      typeof s.courierIdentificationNumber !== "undefined"
        ? s.courierIdentificationNumber
        : "",
      typeof s.preferredPickupDate !== "undefined" ? s.preferredPickupDate : "",
      new PickupDTO(),
      typeof s.printPackageReference !== "undefined"
        ? s.printPackageReference
        : false,
      typeof s.customsDutiesToCustomer !== "undefined"
        ? s.customsDutiesToCustomer
        : false,
      typeof s.clientIdentifier !== "undefined" ? s.clientIdentifier : "",
      typeof s.documents !== "undefined" ? s.documents : [new DocumentDTO()],
      typeof s.customerAccount !== "undefined" ? s.customerAccount : "",
      typeof s.quantumViewNotification !== "undefined"
        ? s.quantumViewNotification
        : new QuantumViewNotificationDTO(),
      typeof s.source !== "undefined" ? s.source : "ONLINE",
      typeof s.status !== "undefined" ? s.status : "DRAFT_TO_BE_CLOSED",
      typeof s.manual !== "undefined" ? s.manual : false,
      typeof s.courierTaxedWeight !== "undefined" ? s.courierTaxedWeight : 0,
      typeof s.customerTaxedWeight !== "undefined" ? s.customerTaxedWeight : 0,
      typeof s.checked !== "undefined" ? s.checked : false,
      typeof s.accountCongifuration !== "undefined"
        ? s.accountCongifuration
        : new CourierServiceCodeConfigurationDTO(),
      typeof s.agentName !== "undefined" ? s.agentName : "",
      typeof s.freightCollect !== "undefined" ? s.freightCollect : false,
      typeof s.specialtyId !== "undefined" ? s.specialtyId : 0,
      typeof s.vatId !== "undefined" ? s.vatId : 0,
      typeof s.vatPercentage !== "undefined" ? s.vatPercentage : 0,
      typeof s.vatName !== "undefined" ? s.vatName : "",
      typeof s.vatCode !== "undefined" ? s.vatCode : "",
      typeof s.modifiedShipNetPrice !== "undefined"
        ? s.modifiedShipNetPrice
        : null,
      typeof s.mbeTracking !== "undefined" ? s.mbeTracking : "",
      typeof s.locale !== "undefined" ? s.locale : "",
      typeof s.canPrintWayBill !== "undefined" ? s.canPrintWayBill : false,
      typeof s.enableCustomerCredit !== "undefined"
        ? s.enableCustomerCredit
        : false,
      typeof s.profitBusinessId !== "undefined" ? s.profitBusinessId : 0,
      typeof s.currency !== "undefined" ? s.currency : "",
      typeof s.sourceTypeBusiness !== "undefined"
        ? s.sourceTypeBusiness
        : "ONLINEMBE_NOWAYBILL",
      typeof s.importedShipment !== "undefined" ? s.importedShipment : false,
      typeof s.saveShipmentTemplate !== "undefined"
        ? s.saveShipmentTemplate
        : false,
      typeof s.priceSource !== "undefined" ? s.priceSource : "",
      typeof s.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase !==
      "undefined"
        ? s.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase
        : false,
      typeof s.requestedChargeCustomDuties !== "undefined"
        ? s.requestedChargeCustomDuties
        : false,
      typeof s.shipmentSource !== "undefined" ? s.shipmentSource : "",
      s.productElink !== "undefined" ? s.productElink : "",
      typeof s.dismissedExtraServices !== "undefined"
        ? s.dismissedExtraServices
        : undefined,
      typeof s.sentPaperlessDocument !== "undefined"
        ? s.sentPaperlessDocument
        : undefined,
      typeof s.paperlessDocumentIds !== "undefined"
        ? s.paperlessDocumentIds
        : undefined,
      typeof s.distanceFromTo !== "undefined" ? s.distanceFromTo : undefined,
      typeof s.correctionSettings !== "undefined"
        ? s.correctionSettings
        : undefined,
      typeof s.autopilotCourierIdBusiness !== "undefined"
        ? s.autopilotCourierIdBusiness
        : undefined,
      typeof s.autopilotCourierName !== "undefined"
        ? s.autopilotCourierName
        : undefined,
      typeof s.autopilotFee !== "undefined" ? s.autopilotFee : undefined,
      typeof s.taxAndDutyId !== "undefined" ? s.taxAndDutyId : undefined,
      typeof s.taxAndDutyPluginAct !== "undefined"
        ? s.taxAndDutyPluginAct
        : undefined,
      typeof s.mbePickupManual !== "undefined" ? s.mbePickupManual : undefined,
      typeof s.ddpZonos !== "undefined" ? s.ddpZonos : false,
      typeof s.pickupDate !== "undefined" ? s.pickupDate : undefined,
      typeof s.landedCosts !== "undefined" ? s.landedCosts : null,
      typeof s.requestedChargeCustomDutiesDefinedByMolUser !== "undefined"
        ? s.requestedChargeCustomDutiesDefinedByMolUser
        : undefined,
      typeof s.codeAccountForCustomDuties !== "undefined"
        ? s.codeAccountForCustomDuties
        : undefined,
      typeof s.zipCodeForCustomDuties !== "undefined"
        ? s.zipCodeForCustomDuties
        : undefined,
      typeof s.countryCodeForCustomDuties !== "undefined"
        ? s.countryCodeForCustomDuties
        : undefined
    );
  }
}

export interface CourierPackageTypeDTO {
  idCourierPackType: number;
  idMBEBusiness: number;
  tenantId: number;
  packTypeDescription: string;
  idCourier: number;
  idMBEPackType: number;
  translatedDescription: string;
  packTypeTemplateDTO?: PackTypeTemplateDTO;
}

export interface PackTypeTemplateDTO {
  idPackTypeTemplate: number;
  courierPackTypeId: number;
  height: number;
  width: number;
  depth: number;
  tenantId: number;
}

export interface OnlineMbeConfigurationDTO {
  onlineMbeConfigurationId: number;
  username: string;
  customerId: number;
  tenantId: number;
  language: string;
  departmentId: number;
  isDepartmentMandatory: boolean;
  onlySelectedDepartments: boolean;
  disableAddressValidation: boolean;
  canSelectCourier: boolean;
  disablePaperlessFeature: boolean;
  enablePaperlessPostClosure?: boolean;
  canSelectCourierService: boolean;
  canSelectMBEService: boolean;
  canSelectSShipmentType: boolean;
  canRequestCustomDuties: boolean;
  customerAddressAsSender: boolean;
  canMergeWaybills: boolean;
  canPrintWaybill: boolean;
  canPrintManifest: boolean;
  internalReferenceInSender: boolean;
  maxShipmentWeight: number;
  maxPackageWeight: number;
  packageSizeMandatory: boolean;
  multiplePackages: boolean;
  trackingVisibility: string;
  courierTrackingNumberVisible: boolean;
  showPrices: boolean;
  showPricesWithSurchargesDetails: boolean;
  showTransitTime: boolean;
  etaFallbackActive: boolean;
  showShipmentsWithSameCustomerId: boolean;
  showPickupsWithSameCustomerId: boolean;
  canDeleteShipments: boolean;
  showLinkToMBEPrivileges: boolean;
  showInvoices: boolean;
  showRequestTermConditionAgreement: boolean;
  termConditionAgreementAccepted: boolean;
  termConditionAgreementAcceptanceDate: number;
  showRequestSafeValueAgreement: boolean;
  safeValueAgreementAccepted: boolean;
  safeValueAgreementAcceptanceDate: number;
  smartchoiceId: number;
  active: boolean;

  departments: { [index: string]: string };
  senderAddress: boolean;
  pickupMaxTime: string; // HH:mm:ss
  pickupMessage: string;
  proformaEnabled: boolean;
  goodTypeEnabled: boolean;
  goodCurrencyEnabled: boolean;
  visiblePriceInShipmentHistory: boolean;
  visiblePriceInWaybill: boolean;
  pickupEnabled: boolean;
  printInternalNoteInOnlineMBEWaybill: boolean;
  automaticShipmentClosure: boolean;
  enableSaveDefaultShipmentSettings: boolean;
  pickupPerson: string;
  pickupOrder: string;
  pickupLocations: OnlineMbePickupLocationDto[];
  enableShipmentsImportXls: boolean;
  enableEmailProductDetails: boolean;
  closingEmailProductDetails: boolean;
  smartChoiceSetting: SmartChoiceSettingEnum;
  showPrivacyInformation: boolean;
  translateElinkServiceCode: boolean;
  privacyAcceptanceDate: string; // date time
  convertMbeWaybillToHtml: boolean;
  keyvalueEnabled: boolean;
  ebayEnabled: boolean;
  amazonEnabled: boolean;
  apykeyEnabled: boolean;
  duties: DutiesSettingEnum;
  showPricesWithSurchargeDetails: boolean;
  enableQapla: boolean;
  qaplaLevel: string;
  canCustomizeStoredCustomDuties?: boolean;
  showDefaultPackageSettings: boolean;
  shipmentEmailsRegistrationEnabled?: boolean;
  enableWineShipmentCreation?: boolean;
  enableSpiritsShipmentCreation?: boolean;
  printOnlineUrl?: boolean;
}

export interface OnlineMbePickupLocationDto {
  id: number;
  tenantId: number;
  pickupLocation: PickupLocationType;
  onlineMbeConfigurationId: number;
  active: boolean;
}

export interface EmailRegistrationDTO {
  id?: number;
  email: string;
  onlineMbeConfigurationId?: number;
  sent: boolean;
  exception: boolean;
  delivered: boolean;
}

export type SmartChoiceSettingEnum =
  | "SIMPLIFIED_SMARTCHOICE"
  | "CUSTOMER_SMARTCHOICE"
  | "BOTH"
  | "NONE"
  | "AUTOPILOT";
export type DutiesSettingEnum =
  | "IMPORT_EXPORT"
  | "IMPORT_ONLY"
  | "EXPORT_ONLY"
  | "BY_COURIER_SERVICE"
  | "NONE";

export type PickupLocationType =
  | "CUSTOMER_ADDRESS"
  | "MBE_STORE"
  | "DEPARTMENT_ADDRESS";

export type ResponseType = "SUCCESS" | "INFO" | "WARNING" | "ERROR";

export interface MessageResult {
  code: string;
  responseType: ResponseType;
  description: string;
  fields: string[];
  checked: boolean;
  params: string[];
}

export interface ResultLockUnlockDto {
  shipmentId: string;
  lockedByUser: string;
  messages?: MessageResult[];
}

export interface BusinessRulesErrorResult {
  messages: MessageResult[];
}

export interface CreateOrUpdateShipmentDTO {
  messageResult: BusinessRulesErrorResult;
  shipment: ShipmentDTO;
}

export interface ShipmentRatesDTO {
  shipments: ShipmentRatesShipmentDTO[];
  localStrategyActive: boolean;
}

export interface ShipmentRatesShipmentDTO {
  first: number;
  second: ShipmentDTO;
}

export interface ShipmentRatesResultDTO {
  bulkId: number;
  errorMessage: string;
  rateShipmentInfoDtoList: RateShipmentInfoDTO[];
}

export interface RateShipmentInfoDTO {
  days: number;
  estimatedDeliveryDate: number;
  estimatedDeliveryDay: string;
  guaranteed: boolean;
  rateFromWebService: boolean;
  rateTimeVisible: boolean;
  remoteArea: boolean;
  service: string;
  serviceIdBusiness: string;
}

export interface AddressSearchShipmentDTO {
  companyName: string;
  address: string;
  secondAddress: string;
  thirdAddress: string;
  city: string;
  province: string;
  zipCode: string;
  subcountryId: number;
  subcountry: string;
  countryId: string;
  countryName: string;
  addressCountryISOCode: string;
  contact: string;
  vatNumber: string;
  phone: string;
  secondPhone: string;
  fax: string;
  email: string;
  secondEmail: string;
  residential: boolean;
  pickupExemption: boolean;
  macroareaName: string;
}
export interface ProductElinkDto {
  skucode?: string;
  description: string;
  quantity: number;
}

export interface SearchShipmentDTO {
  shipmentId: string;
  shipmentDate: string;
  addressFrom: AddressShipmentDTO;
  addressTo: AddressShipmentDTO;
  courierServiceName: string;
  mbeService: string;
  mbeServiceId: number;
  courierId: number;
  courierName: string;
  courierWeight: number;
  courierVolumetricWeight: number;
  customerVolumetricWeight: number;
  customerWeight: number;
  courierShipPackType: string;
  goodDescription: string;
  lockedByUser: string;
  shipmentDirection: string;
  mosDescription: string;
  status: string;
  proforma?: ProformaDTO;
  elinkReturn?: boolean;
  isEcommerceReturn?: boolean;
  paperlessDocumentIds: number[];
}

export interface SearchInvoiceDTO {
  // creationDate : null,
  // lastUpdateDate: null,
  // emissionDate: null,
  // version: null,
  active: boolean;
  // createdByRequestId: null,
  // modifiedByRequestId: null,
  // createdByUser: null,
  // modifiedByUser: null,
  // createdByImpersonator: null,
  // modifiedByImpersonator: null,
  documentId: string;
  documentHead: DocumentHeadInvoiceDTO;
  // documentDetails: null,
  // vatGroupings: null,
  // documentDueDates: null,
  new: boolean;
  id: string;
}

export interface DocumentHeadInvoiceDTO {
  // creationDate: null,
  // lastUpdateDate: null,
  // emissionDate: null,
  // version: null,
  active: boolean;
  // createdByRequestId: null,
  // modifiedByRequestId: null,
  // createdByUser: null,
  // modifiedByUser: null,
  // createdByImpersonator: null,
  // modifiedByImpersonator: null,
  // documentHeadId: null,
  // tenantId: null,
  // storeId: null,
  // multistoreId: null,
  // referToDocumentHeadId: null,
  // salesTypeId: null,
  salesTypeName: string;
  // salesCounterSettingId: null,
  saleDate: string;
  formattedSaleNumber: string;
  // counterValue: null,
  // customerId: null,
  // customerPrivilegesId: null,
  customerBusinessName: string;
  // customerAddress: null,
  // customerAddressCity: null,
  // customerAddressProvince: null,
  // customerAddressZipCode: null,
  // customerAddressCountryIsoCode: null,
  // customerAddressCountryName: null,
  customerVatNumber: string;
  // customerFiscalCode: null,
  // customerVatCodeId: null,
  // customerVatPercentage: null,
  // customerAuthorizationNumber: null,
  // customerApplyVatAlsoOnExemptedArticles: null,
  // departmentId: null,
  // departmentName: null,
  // departmentAddress: null,
  // departmentAddressCity: null,
  // departmentAddressProvince: null,
  // departmentAddressZipCode: null,
  // departmentAddressCountryIsoCode: null,
  // departmentAddressCountryName: null,
  // storeCode: null,
  // storeAddress: null,
  // storeSecondAddress: null,
  // storeThirdAddress: null,
  // storeAddressCity: null,
  // storeAddressProvince: null,
  // storeAddressZipCode: null,
  // storeAddressCountryIsoCode: null,
  // storeAddressCountryName: null,
  // storeContact: null,
  // storeVatNumber: null,
  // storeFiscalCode: null,
  // storeReaCode: null,
  // storeFax: null,
  // storePhone: null,
  // storeEmail: null,
  // storeSecondEmail: null,
  netAmount: number;
  grossAmount: number;
  // currency: null,
  // isRoyaltyExempted: null,
  // sentByEmail: null,
  // sentByEmailDate: null,
  // isSuspended: null,
  // suspendedReason: null,
  // contactPerson: null,
  // isSupplied: null,
  // publicAdministration: null,
  // splitPayment: null,
  // description: null,
  isDigitalSent: boolean;
  // loyaltyTransactions: null,
  // numberOfImpressions: null,
  // lastImpressionDate: null,
  // electronicDocumentType: null,
  // isArt73: null,
  // paymentMethodId: null,
  // paymentMethodName: null,
  // paymentMode: null,
  // paymentDueDate: null,
  // vatChargeability: null,
  // recipientCode: null,
  // denomination: null,
  // paDescription: null,
  // internalCode: null,
  // sectional: null,
  // documentSource: null,
  // hash: null,
  // archived: null,
  // paymentTermId: null,
  // shipmentInfo: null,
  // documentFiles: null,
  importedDocument: boolean;
  new: boolean;
  // id: null
}

export interface ShipmentDetailsInputDTO {
  mbeServiceIdBusiness: number;
  mbePackTypeIdBusiness: number;
  courierServiceIdBusiness: number;
  courierIdBusiness: number;
  courierName: string;
  courierPackTypeIdBusiness: number;
  idMBECustomer: string;
  idSubcountryFrom: number;
  idSubcountryTo: number;
  shipType: ShipType;
  packageNumber: number;
  packages: PackageDTO[];
  shipmentSurchargesList: ShipmentExtraServiceDTO[];
  mbeProducts: ShipProductMBEDTO[];
  idStore: number;
  idMultistore: number;
  countryCode: string;
  idCountryFrom: string;
  idCountryTo?: string;
  cityFrom: string;
  cityTo: string;
  provinceFrom: string;
  provinceTo: string;
  zipCodeFrom: string;
  zipCodeTo: string;
  storeZipCode?: string;
  storeCity?: string;
  goodTypeId: number;
  manualPrice: number | null;
  manualCost: number | null;
  useOtherExtraServiceAndShipmentAndExtraServiceValueForBase: boolean;
  shipmentDate: string;
  proformaValue?: number;
  addressFrom?: AddressShipmentDTO; //to be sent for UPS shipments always
  addressStore?: AddressShipmentDTO; //to be sent for UPS shipments always
  addressTo?: AddressShipmentDTO; //to be sent for with customsDutiesToCustomer
  customsDutiesToCustomer?: boolean;
  skipAutoApply?: boolean;
  requestedChargeCustomDuties?: boolean;
  dismissedExtraServices?: ShipmentExtraServiceDTO[];
  distance?: number;
  autopilotCourierIdBusiness?: number;
  autopilotCourierName?: string;
  languageCode?: string;
  customDutiesQuoteRequested?: boolean;
  proformaDetails?: ProformaDetailsManagementDef[];
  sentPaperlessDocument?: boolean;
  proformaCurrency?: string;
  proformaIncoterms?: string;
  taxAndDutyExternalCall?: boolean;
  ddpZonos?: boolean;
  pickupRequested?: boolean;
  pickupDate?: string;
}

export interface ShipmentCostInputDTO {
  idStore: number;
  courierIdBusiness: number;
  courierName: string;
  courierServiceIdBusiness: number;
  courierZoneIdBusiness: number;
  courierPackTypeIdBusiness: number;
  packageNumber: number;
  shipmentType: ShipType;
  taxedCourierWeight: number;
}

export interface SimpleTaxDutyConfigurationDTO {
  active: boolean;
  packageCalls: number;
  zonosActive?: any;
}

export interface ShipmentApplicableExtraServicesInputDTO {
  mbeServiceIdBusiness: number;
  courierServiceIdBusiness: number;
  courierIdBusiness: number;
  courierPackTypeIdBusiness: number;
  idMBECustomer: string;
  idSubcountryFrom: string;
  idSubcountryTo: string;
  shipType: ShipType;
}

export interface ShipmentExtraServicesValuesInputDTO {
  mbeServiceIdBusiness: number;
  courierServiceIdBusiness: number;
  surcharges: CourierMBEExtraServiceDTO[];
  packages: PackageDTO[];
  courierIdBusiness: number;
  courierPackTypeIdBusiness: number;
  shipmentCost: number;
  shipmentPrice: number;
  idMBECustomer: string;
  shipType: ShipType;
  idMacroarea: number;
  vatValueForPrice: number;
  vatValueSubcountry: number;
  taxedCustomerWeight: number;
  taxedCourierWeight: number;
  idStore: number;
  countryCode: string;
  idCustomer: number;
  netTaxAndDutyTotalPrice?: number;
}

export interface ShipmentPriceInputDTO {
  idStore: number;
  idCustomer: number;
  mbeServiceIdBusiness: number;
  customZoneIdBusiness: number;
  mbePackTypeIdBusiness: number;
  packageNumber: number;
  shipmentType: ShipType;
  taxedCustomerWeight: number;
}

export interface ShipmentWeightInputDTO {
  courierIdBusiness: number;
  courierServiceIdBusiness: number;
  mbeServiceIdBusiness: number;
  idCustomer: number;
  idStore: number;
  packages: SmartChoiceConsultationPackageDTO[];
  subcountryFromId: number;
  subcountryToId: number;
  shipmentType: ShipType;
}

export interface CourierMBEExtraServiceDTO {
  idMbeExtraService: number;
  idMBEBusiness: number;
  tenantId: number;
  description: string;
  changeableAnyTime: boolean;
  extraServiceOrder: number;
  surchargeType: SurchargeType;
  profitId: number;
  overrideVatUser: boolean;
  overrideVatCustomer: boolean;
}
export interface Sv4bConfigurationDTO {
  range2Max: string;
  range1Min: string;
  configurations: ConfigurationDTO[];
}

export interface PackageDTO {
  sequence: number;
  depth: number;
  width: number;
  height: number;
  customerWeight: number;
  courierWeight: number;
  customerTaxedWeight: number;
  courierTaxedWeight: number;
  courierVolume: number;
  customerVolume: number;
  itemsNumber: number;
  specialItemsNumber: number;
  firstLongerSide: number;
  secondLongerSide: number;
  thirdLongerSide: number;
  girth: number;
  firstGirth: number;
  maxSum: number;
  volume: number;
  inputMBEDimensionalSurcharge1: boolean;
  inputMBEDimensionalSurcharge2: boolean;
  inputMBEDimensionalSurcharge3: boolean;
  inputCourierDimensionalSurcharge1: boolean;
  inputCourierDimensionalSurcharge2: boolean;
  inputCourierDimensionalSurcharge3: boolean;
  outputMBEDimensionalSurcharge1: boolean;
  outputMBEDimensionalSurcharge2: boolean;
  outputMBEDimensionalSurcharge3: boolean;
  outputCourierDimensionalSurcharge1: boolean;
  outputCourierDimensionalSurcharge2: boolean;
  outputCourierDimensionalSurcharge3: boolean;
  winePackType?: string;
}

export interface ClosuresDetailsDTO {
  onlineMBEClosureId: number;
  tenantId: number;
  multistoreId: number;
  storeId: number;
  customerId: number;
  username: string;
  manifestNumber: string;
  totalNumberOfShipments: number;
  totalNumberOfPackages: number;
  shipmentIdSet: string[];
}

export interface ClosuresDTO {
  totalPages: number;
  totalElements: number;
  sort: object;
  first: boolean;
  numberOfElements: number;
  last: boolean;
  size: number;
  content: ClosuresDetailsDTO[];
  number: number;
}

export interface ShipmentLandedCostsItemDTO {
  hsCode: string;
  position: number;
  restricted: boolean;
}

export interface ShipmentLandedCostsDTO {
  costGuaranteed: boolean;
  items: ShipmentLandedCostsItemDTO[];
  taxAndDutyId: string;
  totalCosts: number;
  totalGrossCosts: number;
  amountSubtotal: CustomDutyDetailsDTO;
}

export interface ShipmentDetailsOutputDTO {
  courierZoneIdBusiness: number;
  idCustomer: number;
  customZoneIdBusiness: number;
  mbePackTypeIdBusiness: number;
  courierPackTypeIdBusiness: number;
  idCourierZoneElement: number;
  idMacroarea: number;
  vatValueForPrice: number;
  vatValueSubcountry: number;
  customerVolume: number;
  courierVolume: number;
  taxedCustomerWeight: number;
  taxedCourierWeight: number;
  totalNetPrice: number;
  totalGrossPrice: number;
  shipmentNetPrice: number;
  shipmentGrossPrice: number;
  totalCost: number;
  publicPrice: number;
  shipmentFreightCost: number;
  shipmentFreightAndExtraServiceCost: number;
  surcharges: ShipmentExtraServiceDTO[];
  packages: PackageDTO[];
  vatId: number;
  vatCode: string;
  vatName: string;
  profitId: number;
  productMBECost?: number;
  courierBusinessId: number;
  courierName: string;
  courierServiceBusinessId: number;
  courierServiceName: string;
  courierServiceId: number;
  priceSource: string;
  mbeProducts?: ShipProductMBEDTO[];
  useOtherExtraServiceAndShipmentAndExtraServiceValueForBase?: boolean;
  dismissedExtraServices?: ShipmentExtraServiceDTO[];
  autopilotAvailableCouriers?: number[];
  courierTierId?: number;
  landedCosts?: ShipmentLandedCostsDTO;
}

export interface PickupsDTO {
  content: PickupDetailsDTO[];
}

/**
 * StorePickupDTO on backend
 */
export interface PickupDetailsDTO {
  pickupId?: number;
  tenantId: number;
  pickupDate: string; // yyyy-MM-dd
  pickupTime: string; // HH:mm:ss
  packages: number;
  customerId: number;
  storeId: number;
  notes: string;
  messageResult?: BusinessRulesErrorResult;
  departmentId?: number;
  departmentBusinessName?: string;
  totalCustomerWeight: number;
}

export interface RangeTimeDTO {
  name: string;
  fromRange: string;
  toRange: string;
}

export interface BusinessHourDTO {
  day: string;
  rangeTime: RangeTimeDTO[];
}

export type AttachedType = "EMPTY" | "ATTACHED_INVOICE" | "ATTACHED_INVOICE_2";

export interface MultiStoreDTO {
  tenantId: number;
  id: number;
  tenantCountryData: any;
  ownerId: number;
  ownerData: ContactDTO;
  businessName: string;
  commercialName?: string;
  multiStoreType: string;
  countryName: string;
  countryId: string;
  registeredAddress: AddressDTO;
}

export interface ZoneDTO {
  region: string;
  country: string;
  longitude: number;
  latitude: number;
  timeZoneId: string;
}

export interface StoreFooterInfoDTO {
  position: number;
  rowContent: string;
}

export interface StoreDTO {
  areaFranchiseId: string;
  tenantId: number;
  id: number;
  multistore: MultiStoreDTO;
  storeCode: string;
  currency: string;
  state: string;
  businessHours: BusinessHourDTO[];
  multiStoreId: number;
  zone: ZoneDTO;
  classDfs: string;
  segmentPs: string;
  contractNumber: string;
  adhesionDfs: boolean;
  supervisorId: string;
  areaManagerId: string;
  ecommerce: boolean;
  adhesionSafeValue: boolean;
  areaManagerSpvId: string;
  footer: StoreFooterInfoDTO[];
  showCourierSection: boolean;
  showCourierService: boolean;
  attachedType: AttachedType;
  website: string;
}

export interface CreateStoreDTO {
  store: StoreDTO;
  storeAddresses: AddressDTO[];
  bankAccounts: BankAccountDTO[];
  contactReferences: ContactReferenceDTO[];
}

export interface OnlineMBEExtraServiceDto {
  onlineMBEExtraServiceId: number;
  username: string;
  customerId: number;
  showPrice: string;
  tenantId: number;
  extraServiceMaxValue?: number; //can be undefined, undefined same as zero -> unlimited
  extraServiceId: number;
  active: boolean;
}

export interface OnlineMbeCourierVisibilityDto {
  onlineMbeCourierVisibilityId: number;
  username?: string;
  customerId?: number;
  tenantId?: number;
  shipmentType: ShipType;
  mbeServiceId: number;
  courierServiceId: number;
  canPrintWaybill?: boolean;
  courierAccount: string;
  canRequestPickup: boolean;
  canRequestCustomDuties: boolean;
  active: boolean;
  courierServiceIdBusiness: number;
}

export interface OnlineMBEThermicConfigDto {
  onlineMBEPrintThermicFormatId: number;
  username: string;
  courierId: number;
  customerId: number;
  printThermicFormat: boolean;
  tenantId: number;
  active: boolean;
}

export interface ExtraServiceTypesDTO {
  extraServiceTypeId: number;
  tenantId: number;
  internalCode: string;
  defaultPaymentType: boolean;
  paymentMethodId: number | null;
  paymentMethodDescription: string | null;
}

export interface PaymentTypesDTO {
  extraServicePaymentTypeId: number;
  tenantId: number;
  shipmentRegistration: boolean;
  paymentType: string;
  description: string;
  extraServiceTypeList: ExtraServiceTypesDTO[];
}

export interface CourierServiceCodesConfigurationDto {
  id: number;
  tenantId: number;
  courierServiceCategory: CourierServiceCategoryDto;
  multistoreId: number;
  courierId: number;
  shipmentType: ShipType;
  additionalParameters: KeyValueDto[];
  codesConfiguration: StoreServiceCodeConfigurationDto[];
  resale: boolean;
}

export interface CourierServiceCategoryDto {
  id: number;
  tenantId: number;
  idCourierService: number;
  categoryDescription: string;
}

export interface KeyValueDto {
  key: string;
  value: string;
}

export interface StoreServiceCodeConfigurationDto {
  id: number;
  tenantId: number;
  idStore: number;
  idCodeConfiguration: number;
}

export interface OnlineMbeShipmentTemplateDto {
  shipmentTemplateId?: number;
  tenantId: number;
  customerId: number;
  username: string;
  weight: number;
  depth: number;
  width: number;
  height: number;
  content: string;
}

export interface ZipRegistryEntryDto {
  id: ZipRegistryEntryIdDto;
  destinationStation?: string;
  depotName?: string;
  controllingStation?: string;
  zone?: string;
  satelliteCode?: string;
  guaranteed?: string;
  elite?: string;
  deliveryParty?: string;
  saturday?: string;
  domFlag?: string;
}

export interface ZipRegistryEntryIdDto {
  country: string;
  countryName: string;
  postcodeFrom: string;
  postcodeUntil: string;
  townName: string;
  province?: string;
}

export interface ForgotPasswordDTO {
  //email OR username required
  email?: string;
  emailCheck?: string;
  username?: string;
  usernameCheck?: string;
}

export interface ValidatePasswordTokenDTO {
  token: string;
}

export interface ChangePasswordTokenDTO {
  token: string;
  newPasswordCheck: string;
  newPassword: string;
}

export interface ApiResponse {
  code: string;
  type: string;
  message: string;
  detail: string;
}

export interface MetadataField {
  field: string;
  display?: string;
  defaultValue?: string;
  type: FieldType;
  typeSpec: string;
  group: string;
  visible?: boolean;
  required?: boolean;
  size?: string;
  regex?: string;
}

export interface PresetField {
  field: string;
  type: FieldType;
  typeSpec?: string;
  group?: string;
  editable: boolean;
  visible: boolean;
}

export interface SearchMetadataDto {
  tenantId: number;
  multistoreId?: number;
  storeId?: number;
  username?: string;
  filters: MetadataField[];
  presets: PresetField[];
  context?: string;
  label?: string;
}
export type FieldType =
  | "INTEGER"
  | "DECIMAL"
  | "CURRENCY"
  | "CHOOSE_ONE"
  | "CHOOSE_ANY"
  | "CHOOSE_ONE_INTEGER"
  | "CHOOSE_ANY_INTEGER"
  | "INTEGER_LIST"
  | "BOOLEAN"
  | "PRESENCE"
  | "TEXT"
  | "DATE"
  | "DATETIME";

export interface OnlineMbePackTypeDto {
  onlineMbePackTypeId: number;
  tenantId: number;
  customerId: number;
  username: string;
  packTypeDescription: string;
  packtypeBusinessId: number;
  active: boolean;
}

export interface IApiKeyListBody {
  idRole?: number;
  idEntity?: number;
  legalEntityType: string;
  showInactive?: boolean;
  username?: string;
  sort?: string;
  number?: number;
  size?: number;
}

export interface MbePackTypeDTO {
  idMBEPackType: number;
  idMBEBusiness: number;
  tenantId: number;
  packTypeDescription: string;
  translatedDescription: string;
}

export interface UuidData {
  businessName: string | null;
  customerId: number;
  email: string | null;
  idRefContact: number;
  language: string | null;
  firstName: string | null;
  lastName: string | null;
  tenantId: number;
  mbeCustomerId: number;
  multistoreId: number;
  type: GdprUuidExpiredConsent;
}

export type GdprUuidExpiredConsent = "EXPIRED_CONSENT" | "NEW_POLICY_VERSION";

export interface GdprVersionsDto {
  attachmentId: number;
  elements: GdprVersionElementsDTO;
  name: string;
  date: string;
  policyVersion: number;
  disabled?: boolean;
}
export interface GdprVersionElementsDTO {
  [id: number]: string;
}

export interface GdprSourcesDTO {
  [s: string]: any;
}

export type GdprConsentChangePlatform =
  | "MBE_HUB"
  | "MBE_ONLINE"
  | "LANDING_PAGE"
  | "SYSTEM";

export interface GdprAssociationDto {
  idGdprAssociation?: number;
  associationDateTime: string; // dd/MM/yyyy HH:mm
  idRefAddress: number;
  value: number; // -1 for "not set", 0 for denied, 1 for allowed
  idGdprElement: number;
  idGdprSource: number;
  gdprElement: GdprElementDto;
  gdprSource: GdprSourceDto;
  active?: boolean;
  creationDate?: string;
  lastUpdateDate?: string;
}

export interface GdprElementDto {
  description: string | null;
  idGdprElement: number;
  name: string;
  tenantId: number;
}

export interface GdprSourceDto {
  description: string | null;
  idGdprSource: number;
  name: string;
  tenantId: number;
}

export interface CreateGdprAssociationDto {
  gdprAssociationDtos: GdprAssociationDto[];
  consentChangePlatform: GdprConsentChangePlatform;
}

export enum associationKeys {
  VISION = "vision",
  MARKETING_CENTRE = "mktgCenter",
  MARKETING_MBE = "mktgCorporate",
  PROFILING = "profiling",
  TERMINATION = "cession"
}

export type AssociationElementNames = keyof typeof associationKeys;

export enum GdprElementType {
  vision = "VISION",
  marketing_centre = "MARKETING_CENTRE",
  marketing_mbe = "MARKETING_MBE",
  profiling = "PROFILING",
  termination = "TERMINATION"
}

export const associationElementNames: AssociationElementNames[] = [
  GdprElementType.vision,
  GdprElementType.marketing_centre,
  GdprElementType.marketing_mbe,
  GdprElementType.profiling,
  GdprElementType.termination
];

export type GdprErrorCode =
  | "CONSENT_POLICY_VERSION_HIGHER_THAN_ANY_ACCEPTED"
  | "INVALID_COLLECTION_OF_GDPR_ELEMENT_TYPES_PROVIDED"
  | "INCONSISTENT_PRIVACY_POLICY_VERSIONS";

export interface GdprErrorDTO {
  code: GdprErrorCode;
  message: string;
  type: string;
}

export interface Oauth2TokenDef extends Oauth2TokenResponse {
  timestamp: number; //token store timestamp
  access_token_expire_timestamp: number;
  refresh_token_expire_timestamp: number;
}

export interface EcommerceOutcomeDetailsDto {
  idEcommerceOutcomeDetails: number;
  idEcommerceOutcome: number;
  orderNumber: string;
  message: string;
  messageType: ResponseType | string;
  draftShipmentId: string;
}

export interface ErrorShipImportDTO {
  idShipImportMappingsError?: number;
  tenantId?: number;
  msId?: number;
  storeId?: number;
  rowNumber?: number;
  columnNumber?: number;
  errorDetail?: string;
  errorMessage?: string;
  insertDate?: number;
  status?: string;
}

export type ShipImportTemplateEnum = [
  "SHIPMENT_PACKAGE_EXCEL_IMPORT",
  "ONLINE",
  "INTERNET_SHIPPING",
  "SHIPMENT_EXCEL_IMPORT",
  "CAMPUS_SHIP",
  "OTHER"
];

export interface ShipImportNotificationDto {
  idNotification?: number;
  tenantId?: number;
  msId?: number;
  storeId?: number;
  username?: string;
  fileName?: string;
  message?: string;
  insertDate?: number | Date;
  shipImportMappingsErrorEntities?: ErrorShipImportDTO[];
  template?: ShipImportTemplateEnum | string;
}

export interface EcommerceOutcomeDto {
  idEcommerceOutcome: number;
  tenantId: number;
  multistoreId: number;
  storeId: number;
  customerId: number;
  username: string;
  insertDate: string;
  fileName: string;
  totalNumberOfOrders: number;
  ecommerceType: string;
  message: string;
  messageType: ResponseType | string;
  ecommerceOutcomeDetails: EcommerceOutcomeDetailsDto[];
}

export interface ApiKeyRoleLegalEntityDto {
  id: number;
  apiKey: string;
  apiSecret: string;
  idRole: number;
  idLegalEntity: number;
  tenantId: number;
  active: boolean;
  legalEntity: LegalEntityDTO;
  role: RoleDTO;
  username: string;
  creationDate: string; // iso ex "2022-07-01T09:43:13Z"
}

export interface PaperlessDocumentDto {
  businessRulesErrorResult?: BusinessRulesErrorResult;
  id: number;
  tenantId: number;
  multistoreId: number;
  storeId: number;
  courierId: number;
  paperlessCourierDocumentTypeId: number;
  courierDocumentTypeCode: string;
  notes: string;
  contentFormatType: ContentFormatType;
  content: string;
  documentPath: string;
  versionId: string;
  courierDocumentId: string;
  filename: string;
  selected: boolean;
  creationDate: string;
}

export interface ExportMetadataDto {
  exportMetadataId: number;
  tenantId: number;
  username: string;
  exportDate: number;
  filePath: string;
  versionId: number;
}

export type Operation =
  | "="
  | ">"
  | ">="
  | "<"
  | "<="
  | ".."
  | "_."
  | "._."
  | "ALL"
  | "!=";
export interface Clause {
  field: string;
  type: FieldType;
  operation: Operation;
  values: any[];
}
export interface Filter {
  and: Clause[];
  or?: Clause[];
}

export interface CPMDocumentDTO {
  customerName: string;
  courierName: string;
  trackingNumber: string;
  date: Date;
  timeFrom: string;
  timeTo: string;
  alternativeTimeFrom: string;
  alternativeTimeTo: string;
  pickupCode: string;
  note: string;
  creationDate: Date;
  senderAddress: string;
  senderCity: string;
  senderPostcode: string;
  senderCountry: string;
  senderProvince: string;
  senderContactName: string;
  senderPhone1: string;
  senderPhone2: string;
  senderEmail1: string;
  senderEmail2: string;
  sender: string;
  recipientAddress: string;
  senderAddress2: string;
  senderAddress3: string;
  recipientCity: string;
  recipientPostcode: string;
  recipientCountry: string;
  senderSubCountry: string;
  subCountryId: string;
  customerAddress: string;
  customerCity: string;
  customerZIP: string;
  customerCountry: string;
  customerProvince: string;
  customerContactName: string;
  customerPhone1: string;
  customerPhone2: string;
  customerEmail1: string;
  customerEmail2: string;
  customerCompanyName: string;
  customerSecondAddress: string;
  customerThirdAddress: string;
  customerSubCountry: string;
  customerSubCountryId: string;
  customeraAsSender: string;
  selected: boolean;
  id: string;
}

export interface CorrectionSettingsDto {
  priceUpdate: boolean;
  courierWeightUpdate: boolean;
  customerWeightUpdate: boolean;
  createInvoiceRevision: boolean;
  minAmountForInvoiceRevision: number;
  includeRefunds: boolean;
}

export interface InvoiceCheckConfigurationDto {
  idInvoiceCheckConf?: number;
  tenantId: number;
  multistoreId?: number;
  storeId?: number;
  idMbeCustomer?: string;
  customerBusinessName?: string;
  priceUpdate: boolean;
  courierWeightUpdate: boolean;
  customerWeightUpdate: boolean;
  createInvoiceRevision: boolean;
  includeRefunds: boolean;
  minAmountForInvoiceRevision: number;
}

export interface FuelPriceRow {
  serviceName: string;
  serviceId: number;
  fuelPriceItems: FuelPriceItem[];
}

export interface FuelPriceItem {
  value: number;
  percentage: number;
  minimum: number;
  maximum: number;
}

export interface LoginHistoryDTO {
  userId: number;
  username: string;
  event: string;
  clientId: string;
  ipAddress: string;
  userAgent: string;
  role: string;
  tenantId: number;
  creationDate: string;
  impersonator?: string;
  impersonation_chain?: any[];
}

export interface DeviceManagementDTO {
  username: string;
  deviceInfo: string;
  tenantId: number;
  entityType: string;
  entityId: number;
}

export interface IncidentDTO {
  id: string;
  shipmentId: string;
  tenantId: number;
  multistoreId: number;
  shipmentType: null | string;
  storeId: number;
  customerId: number;
  customerName: string;
  courierId: number;
  courierName: string;
  courierServiceId: number;
  courierServiceName: string;
  courierTracking: string;
  mbeServiceId: number;
  mbeServiceName: string;
  mbeTracking: string;
  shipmentSource: string;
  shipmentDate: string;
  countryFrom: string;
  subcountryFrom: string;
  countryTo: string;
  subcountryTo: string;
  insurance: boolean;
  safeValue: boolean;
  safeValue4Business: boolean;
  safeValueType: string;
  active: boolean;
  creationDate: string;
  lastUpdateDate: string;
  receiverEmail: null | string;
  incidentAttachments: null | IncidentAttachmentDTO[];
  claim?: ClaimDTO;
  incidentShipmentCost: number | null;
  incidentProformaValue: number | null;
  claimDraft?: any;
  messages?: ClaimMessageDTO[];
  incidentSource?: string;
}
export interface IncidentAttachmentDTO {
  path: string;
  version: string;
  type: string;
  fileName: string;
  source: string;
  creationDate: string;
  username: string;
}

export interface ClaimCategorizationDTO {
  active: boolean;
  creationDate: string;
  description: string;
  idCategorization: number;
  lastUpdateDate: string;
  multistoreId: null | number;
  storeId: null | number;
  tenantId: number;
}

export interface ClaimDTO {
  priority: string;
  dueDate: string;
  categorization: string;
  errorType: string;
  claimStatus: string;
  errorSubtype: string;
  assigneeId: number;
  assigneeName: string;
  description: string;
  protocolNumber: null | string;
  notes: ClaimNoteDTO[];
}

export interface ClaimNoteDTO {
  text: string;
  username: string;
  noteId: string;
  creationDate: string;
}

export interface ClaimMessageDTO {
  text: string;
  username: string;
  messageId: string;
  creationDate: string;
}

export interface ClaimMessageDTO {
  text: string;
  username: string;
  messageId: string;
  creationDate: string;
}

export interface ClaimErrorSubTypeDTO {
  active: boolean;
  creationDate: string;
  description: string;
  errorSubtypeCode: string;
  errorTypeCode: string;
  lastUpdateDate: string;
  weblateKey: string;
}

export interface ClaimErrorTypeDTO {
  active: boolean;
  creationDate: string;
  description: string;
  errorTypeCode: string;
  lastUpdateDate: string;
  weblateKey: string;
}

export interface ClaimPriorityDTO {
  active: boolean;
  creationDate: string;
  description: string;
  lastUpdateDate: string;
  priorityCode: string;
  weblateKey: string;
}

export interface SearchUserRequestDTO {
  legalEntityId?: number;
  legalEntityType?: string; //STORE MULTISTORE etc
  completeUser?: boolean;
  includeInactive?: boolean;
  username?: string;
  email?: string;
  userType?: string; //ADMIN - USER
  authRoleTypes?: string[]; //STORE_ADMIN - MULTISTORE_USER etc.
  idEntity?: number; //id of the store or multistore
  roleIds?: number; //database id of the role
}
